import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation("glas-vervangen");
  const usps = t("hero.usps", { returnObjects: true }) as string[];

  return (
    <section className="bg-brand-cream w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-12 min-h-[65vh] py-12 md:py-0">
          <div className="flex-1 flex flex-col justify-center md:py-16 lg:py-20">
            <span className="inline-block self-start font-geist-mono text-xs md:text-sm font-bold tracking-wider text-brand-text bg-brand-yellow px-3 py-1.5 rounded-full mb-6 md:mb-8">
              {t("hero.pill")}
            </span>
            <h1 className="font-geist font-bold text-4xl md:text-5xl lg:text-[72px] text-brand-text tracking-tight leading-[1.05] mb-5 md:mb-6">
              {t("hero.h1")}
            </h1>
            <p className="font-geist text-lg md:text-xl text-brand-text/80 leading-relaxed max-w-[520px] mb-6 md:mb-8">
              {t("hero.subhead")}
            </p>

            <ul className="flex flex-col gap-2 mb-8 md:mb-10">
              {usps.map((usp, i) => (
                <li key={i} className="flex items-center gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-brand-yellow">
                    <i className="ri-check-line text-brand-text text-xs w-4 h-4 flex items-center justify-center"></i>
                  </div>
                  <span className="font-geist text-sm md:text-base text-brand-text">{usp}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="tel:+31407987470"
                className="inline-flex items-center gap-2 font-geist font-bold text-sm md:text-base bg-brand-blue text-white px-6 md:px-8 py-3.5 md:py-4 rounded-full hover:bg-brand-text transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                {t("hero.ctaPhone")}
              </a>
              <a
                href="#offerte"
                className="inline-flex items-center gap-2 font-geist font-bold text-sm md:text-base border-2 border-brand-text text-brand-text px-6 md:px-8 py-3 md:py-3.5 rounded-full hover:bg-brand-text hover:text-white transition-colors whitespace-nowrap"
              >
                {t("hero.ctaOfferte")}
              </a>
            </div>
          </div>

          <div className="flex-1 relative min-h-[300px] md:min-h-0 rounded-2xl overflow-hidden">
            <img
              src="/img/62-professional-glazier-installing-double.jpg"
              alt="Vakkundige glaszetter plaatst isolatieglas in Eindhoven"
              className="absolute inset-0 w-full h-full object-cover object-top"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
}